// extracted by mini-css-extract-plugin
module.exports = {"lia-action-delete":"MessageActionDelete_lia-action-delete__G_p_N","lia-edits-disabled":"MessageActionDelete_lia-edits-disabled__69KxP"};